import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {Action, Getter, State} from "vuex-class";
import {AuthScreenMixin} from "~/modules/auth/views/auth-screen-mixins";
import {formatDate} from "~/lib/helpers/formatters";
import {isDefined} from "~/lib/helpers/guards";
import {PendingsAop} from "~/lib/pendings-aop";
import HeroLoader from "~/components/hero-loader";
import {omit} from "~/lib/helpers";
import { className } from "~/lib/helpers/string";
import iconUser from "~/assets/inline-svg/icon_user.svg?inline";
import iconPassword from "~/assets/inline-svg/icon_password.svg?inline";
import iconPasswordVisible from "~/assets/inline-svg/icon_password-visible.svg?inline";
import iconPasswordHidden from "~/assets/inline-svg/icon_password-hidden.svg?inline";
import { EnvConfig } from "~/lib/env-config";


interface SigninPayload { email: string; password: string; }


function lockedUntil(rawMessage: string) {
  return formatDate(parseInt(rawMessage.split("&")[1], 10), "dd-MM-yyyy HH:mm");
}

function getErrorMessage(err = null) {
  console.log("Authentication Error: ", err);
  if (err?.data?.message && err.data.message.startsWith("email.lock")) {
    return `L'email a été bloqué jusqu'au ${lockedUntil(err.data.message)}`;
  } else if (err?.data?.message && err.data.message.startsWith("email.unconfirmed")) {
    return `Votre compte n'est pas encore confirmé. Veuillez cliquer sur le lien présent dans le mail qui vous a été envoyé ou cliquez sur le bouton 'renvoyer' pour recevoir un nouvel e-mail.`;
  }
  return "Connexion échouée";
}


@Component
class Signin extends Mixins(AuthScreenMixin) {

  @Prop({required: false, type: String, default: "/"}) readonly redirection: string;
  @Prop({required: false, type: Boolean, default: false}) readonly fromInactivity: boolean;

  @State(state => state.auth.isLoading) isLoading: boolean;
  @State(state => state.auth.isErrored) isErrored: boolean;
  @State(state => state.auth.error) error: any;

  private body: SigninPayload = { email: null, password: null };
  protected isPasswordVisible = false;


  reset() {
    this.body = { email: null, password: null };
  }
  protected autoConnectPending = new PendingsAop();

  togglePasswordVisibility(e) {
    e.preventDefault();
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  async submit(e: Event) {
    e.preventDefault();
    if (this.body.email && this.body.password) {
      await this.$store.dispatch("authenticate", this.body);
      if (this.isErrored) {
        this.reset();
      } else {
        let home = this.$functionalities("home");
        home ? this.$router.push({ name: home }) : this.$router.push(this.redirection);
      }
    }
  }


  onSuccess() {
    this.$router.push(this.redirection);
  }

  onError(error) {
    this.error = error;
  }

  renderView(){

    return [
      (this.error || this.fromInactivity) && this.renderErrored(getErrorMessage(this.error)), 
      <div class="login-view">
        <form>
          <h1 class="form-title">Se connecter</h1>
            <h3 class="form-subtitle">Un plaisir de vous revoir sur Geoptis Solution !</h3>
            <div class="field with-icon">
              <label for="email" class="label">Email*</label>
              <div class="control">
                <input type="email" class="input" id="email" name="email" v-model={this.body.email} placeholder="Ex: paul.dupont@geoptis.com"/>
                <span class="icon" domPropsInnerHTML={iconUser} />
              </div>
            </div>
            <div class="field with-icon">
              <label for="password" class="label with-forgotten-password-link">Mot de passe*<span><a href={`${EnvConfig("FRONT_URL")}/lost-password`} class="forgotten-password-invite">{this.$t("user.invite")}</a></span></label>
              <div class="control">
                <input type={this.isPasswordVisible ? "text" : "password"} class={["input", {"password-hidden": !this.isPasswordVisible}]} id="password" name="password" v-model={this.body.password}/>
                <span class="icon" domPropsInnerHTML={iconPassword} />
                <div class="icon icon-password-visibility" onClick={this.togglePasswordVisibility} domPropsInnerHTML={this.isPasswordVisible ? iconPasswordHidden : iconPasswordVisible} />
              </div>
            </div>

            <div class="field has-text-centered">
              <button class={className("button btn--action-primary ", {isLoading: this.isLoading})} onClick={this.submit}>
                {this.$t("general.login")}
              </button>
            </div>
        </form>
      </div>
    ]
  }

  render() {

    if(this.autoConnectPending.busy ){
      return <HeroLoader />;
    }

    return this.wrapRenderer(() => (
      <div>

        {this.renderBackground()}

        <section class="signin">
          <div class="inner">
            <div class="logos-with-title">
              {this.renderLogoCustomization()}
              {this.renderTitle()}
            </div>
            {this.renderPoweredBy()}
            {this.renderView()}
          </div>
          {this.renderFrame()}
        </section>
      </div>
    ));
  }
}

export default Signin;


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0fddc075/signin.tsx" });